var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup37(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 420,
    height: 285.196,
    viewBox: "0 0 420 285.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 158,
    height: 163,
    transform: "translate(263.35 47.433)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 20.269,
    height: 20.096,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 23.653,
    height: 24.724,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(0 -24.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(0 24.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M39.991,251.815H27.072A13.483,13.483,0,0,1,13.63,239.343L.04,58.65a13.477,13.477,0,0,1,13.442-14.5H26.4a13.477,13.477,0,0,0-13.442,14.5l13.59,180.693a13.483,13.483,0,0,0,13.442,12.473",
    transform: "translate(0 -44.139)",
    fill: "#50ac53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M43.928,251.815H35.8a13.482,13.482,0,0,1-13.442-12.473L8.772,58.65a13.476,13.476,0,0,1,13.442-14.5h8.124A13.477,13.477,0,0,0,16.9,58.65l13.59,180.693a13.483,13.483,0,0,0,13.442,12.473",
    transform: "translate(-3.936 -44.139)",
    fill: "#ffe033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M320.73,237.292a13.488,13.488,0,0,1-13.5,14.486H50.641a13.5,13.5,0,0,1-13.5-12.446l-.493-6.679c-1.314-17.49,4.807,63.953-13.079-174.035A13.513,13.513,0,0,1,37,44.131H293.657a13.448,13.448,0,0,1,13.431,12.517l.774,10.547,6.118,81.217,2.25,29.674,4.149,54.566Z",
    transform: "translate(-10.609 -44.131)",
    fill: "#f2f3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M318.044,406.563H61.386A13.475,13.475,0,0,1,47.95,394.1l-.494-6.668h283.7l.338,4.639a13.487,13.487,0,0,1-13.45,14.493",
    transform: "translate(-21.393 -198.892)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M309.1,401.527a3.609,3.609,0,0,1-3.59,4.042,4.387,4.387,0,0,1-4.37-3.9,3.6,3.6,0,0,1,3.58-4.042,4.39,4.39,0,0,1,4.38,3.9",
    transform: "translate(-135.746 -203.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M59.915,81.94,70.731,225.585a5.7,5.7,0,0,0,5.679,5.253H311.469a5.688,5.688,0,0,0,5.679-6.12L306.317,81.072a5.7,5.7,0,0,0-5.679-5.252H65.593a5.688,5.688,0,0,0-5.679,6.12",
    transform: "translate(-27.002 -58.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M59.915,81.94l.854,11.428H307.242l-.925-12.3a5.7,5.7,0,0,0-5.679-5.252H65.593a5.688,5.688,0,0,0-5.679,6.12",
    transform: "translate(-27.002 -58.417)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M483.843,92.425a4.138,4.138,0,0,1-4.014-3.41,2.943,2.943,0,0,1,2.935-3.539,4.113,4.113,0,0,1,4.028,3.41,2.971,2.971,0,0,1-2.949,3.539",
    transform: "translate(-216.289 -62.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M458.4,88.886a2.978,2.978,0,0,1-2.949,3.539,4.127,4.127,0,0,1-4.014-3.41,2.941,2.941,0,0,1,2.921-3.539,4.116,4.116,0,0,1,4.043,3.41",
    transform: "translate(-203.488 -62.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M429.976,88.886a2.961,2.961,0,0,1-2.934,3.539,4.142,4.142,0,0,1-4.029-3.41,2.958,2.958,0,0,1,2.935-3.539,4.1,4.1,0,0,1,4.028,3.41",
    transform: "translate(-190.678 -62.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M152.291,89.372a2.6,2.6,0,0,1-2.631,2.952H76.091a3.355,3.355,0,0,1-3.256-2.952,2.6,2.6,0,0,1,2.632-2.943h73.57a3.353,3.353,0,0,1,3.255,2.943",
    transform: "translate(-32.827 -63.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M136.512,144.6h-3.628a.691.691,0,0,1,0-1.381h3.628a.691.691,0,1,1,0,1.381",
    transform: "translate(-59.594 -88.798)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M138.179,164.137h-3.631a.691.691,0,0,1,0-1.381h3.631a.691.691,0,0,1,0,1.381",
    transform: "translate(-60.343 -97.608)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M139.843,183.678h-3.628a.691.691,0,0,1,0-1.381h3.628a.691.691,0,0,1,0,1.381",
    transform: "translate(-61.095 -106.417)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M141.505,203.22h-3.628a.691.691,0,0,1,0-1.381h3.628a.691.691,0,1,1,0,1.381",
    transform: "translate(-61.844 -115.226)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M143.172,222.762H139.54a.691.691,0,0,1,0-1.381h3.631a.691.691,0,0,1,0,1.381",
    transform: "translate(-62.594 -124.036)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M144.836,242.3h-3.628a.691.691,0,0,1,0-1.381h3.628a.691.691,0,0,1,0,1.381",
    transform: "translate(-63.346 -132.842)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M91.955,144.6H84.8a.691.691,0,0,1,0-1.381h7.152a.691.691,0,0,1,0,1.381",
    transform: "translate(-37.918 -88.798)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M93.62,164.137H86.471a.691.691,0,0,1,0-1.381H93.62a.691.691,0,0,1,0,1.381",
    transform: "translate(-38.67 -97.608)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M95.283,183.678H88.134a.691.691,0,0,1,0-1.381h7.148a.691.691,0,0,1,0,1.381",
    transform: "translate(-39.42 -106.417)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M96.948,203.22H89.8a.691.691,0,0,1,0-1.381h7.152a.691.691,0,0,1,0,1.381",
    transform: "translate(-40.169 -115.226)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M98.613,222.762H91.464a.691.691,0,0,1,0-1.381h7.148a.691.691,0,0,1,0,1.381",
    transform: "translate(-40.921 -124.036)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M100.278,242.3H93.127a.691.691,0,1,1,0-1.381h7.151a.691.691,0,0,1,0,1.381",
    transform: "translate(-41.67 -132.842)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M284.1,144.6H245.2a.691.691,0,0,1,0-1.381h38.9a.691.691,0,0,1,0,1.381",
    transform: "translate(-110.227 -88.798)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M197.971,144.6H154.254a.691.691,0,0,1,0-1.381h43.717a.691.691,0,0,1,0,1.381",
    transform: "translate(-69.227 -88.798)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M232.363,164.137H155.917a.691.691,0,0,1,0-1.381h76.446a.691.691,0,0,1,0,1.381",
    transform: "translate(-69.977 -97.608)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M284.619,183.678H248.454a.691.691,0,0,1,0-1.381h36.165a.691.691,0,0,1,0,1.381",
    transform: "translate(-111.693 -106.417)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M197.9,183.678H157.585a.691.691,0,1,1,0-1.381H197.9a.691.691,0,0,1,0,1.381",
    transform: "translate(-70.728 -106.417)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M238.055,203.22H159.247a.691.691,0,0,1,0-1.381h78.807a.691.691,0,0,1,0,1.381",
    transform: "translate(-71.478 -115.226)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M226.39,222.762H160.915a.691.691,0,0,1,0-1.381H226.39a.691.691,0,0,1,0,1.381",
    transform: "translate(-72.23 -124.036)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M277.531,242.3H241.645a.691.691,0,0,1,0-1.381h35.886a.691.691,0,0,1,0,1.381",
    transform: "translate(-108.623 -132.842)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M197.725,242.3H162.578a.691.691,0,1,1,0-1.381h35.147a.691.691,0,0,1,0,1.381",
    transform: "translate(-72.979 -132.842)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M112.967,194.959a.692.692,0,0,1-.687-.633l-5.413-63.531a.69.69,0,0,1,1.375-.114l5.413,63.53a.69.69,0,0,1-.63.745.332.332,0,0,1-.057,0",
    transform: "translate(-48.175 -82.863)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M333.019,317.332c.325,1.282-3.442,2.315-8.444,2.315H175.61c-4.839,0-9.061-.975-9.58-2.215,0-.034-.032-.066-.032-.1l-2.468-9.71c-.325-1.274,3.442-2.315,8.444-2.315H320.938c4.969,0,9.288,1.041,9.613,2.315Z",
    transform: "translate(-73.711 -161.87)",
    fill: "#70b971"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Create_account",
    "data-name": "Create account",
    transform: "translate(148.324 152.484)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "Ubuntu-MediumItalic, Ubuntu",
    fontWeight: 500,
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Create a"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "cc"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ount")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(-1.35 99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M682.858,313.287s-1.333,6.5-6.4,6.232-8.2-13-8.2-13l13.334,2.4Z",
    transform: "translate(-301.253 -138.181)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M611.052,603.667l-2.18,12.3-13.505,1.1,1.217-14.047c3.509,1.76,10.9-.215,14.468.644",
    transform: "translate(-268.394 -271.845)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M580.864,616.879h0a2.087,2.087,0,0,0-2.115-2.059h-.005a2.087,2.087,0,0,0-1.945,1.4l-1.484,4.289-13.765,4.8a4.548,4.548,0,0,0-3.052,4.357.564.564,0,0,0,.572.557l38.486-.519a.565.565,0,0,0,.557-.572l-.071-5.223s-.221-6.572-5.6-7.767c0,0-2.564,5.54-7.843,5.087-3.291-.282-3.74-4.349-3.74-4.349",
    transform: "translate(-251.772 -277.163)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M622.324,628.5a3.952,3.952,0,0,0,.326,3.1l4.118-.055-.039-2.727a10.937,10.937,0,0,0-.66-3.105,3.959,3.959,0,0,0-3.744,2.783",
    transform: "translate(-280.465 -282.076)",
    fill: "#5e6f8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M702.389,603.681v12.46l-13.175,1.124V603.039Z",
    transform: "translate(-310.7 -271.852)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M673.583,616.456h0a2.087,2.087,0,0,0-2.133-2.041h-.005a2.087,2.087,0,0,0-1.933,1.42l-1.449,4.3-13.725,4.909a4.549,4.549,0,0,0-3.016,4.382.565.565,0,0,0,.577.552l38.48-.838a.564.564,0,0,0,.552-.577l-.114-5.223s-.276-6.57-5.659-7.721c0,0-2.519,5.561-7.8,5.153-3.294-.255-3.776-4.318-3.776-4.318",
    transform: "translate(-293.618 -276.98)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M715.064,627.845a3.954,3.954,0,0,0,.351,3.1l4.117-.089-.062-2.727a10.939,10.939,0,0,0-.686-3.1,3.96,3.96,0,0,0-3.721,2.814",
    transform: "translate(-322.277 -281.766)",
    fill: "#5e6f8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M659.719,467.992a3.823,3.823,0,0,1-3.815,3.677H643.587a1.967,1.967,0,0,1-1.77-1.092,1.912,1.912,0,0,1-.195-.781l-24.8-118.863-5.1,116.508a5.772,5.772,0,0,1-5.561,4.228H592.871a.9.9,0,0,1-.885-1.011l-2.539-157.572c4.148-3.4,8.353-5.986,12.673-6.32,4.148-.333,8.422,1.367,12.892,6.32h29.2Z",
    transform: "translate(-265.725 -138.273)",
    fill: "#50ac53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M638.193,380.826a.285.285,0,0,1-.286-.249l-1.057-7.852a.285.285,0,0,1,.245-.325.177.177,0,0,1,.04,0,.285.285,0,0,1,.286.249l1.057,7.852a.286.286,0,0,1-.246.325.205.205,0,0,1-.04,0",
    transform: "translate(-287.093 -167.878)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M543.318,218.2a10.391,10.391,0,0,1-11.746-2.833c-1.062-1.18-2.36-2.715-3.836-4.309l-2.243-30.221,12.985,14.815c.708-.589,1.771-1.416,2.951-2.36Z",
    transform: "translate(-236.894 -81.521)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M608.161,249.517c-37.032,9.881-60.425,13.73-60.311,4.389.2-15.707,2.574-54.921,2.574-54.921l-17.43,10.237a8.884,8.884,0,0,1-10.5-2.057c-6.4-7.135-19.018-22.375-20.04-24.236.655.471,2.827.33,5.423-.831a12.859,12.859,0,0,0,2.011-1.057c3.309-2.148,3.883-4.848,3.883-5.894v-.035a.329.329,0,0,0-.114-.253l.011-.012,14.226,16.2s13.248-10.444,18.464-15.063c5.094-4.486,26.1-11.609,34.711-10.7v-.012a43.92,43.92,0,0,1,7.192.873c4.975,1.011,11.651,4.458,13.294,7.963,4.022,8.641,5.676,27.771,6.308,44.592.218,5.527.322,10.8.368,15.374.08,9.111-.069,15.442-.069,15.442",
    transform: "translate(-226.507 -74.475)",
    fill: "#f2f3f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(361.454 144.227)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M678.42,277.987l-20.269,4.723,19.9-20.1c.218,5.526.322,10.8.368,15.373",
    transform: "translate(-658.151 -262.614)",
    fill: "#b6bab6"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M604.79,110.159c0,5.249,2.489,9.5,5.556,9.5s5.561-4.254,5.561-9.5-2.489-9.5-5.561-9.5-5.556,4.254-5.556,9.5",
    transform: "translate(-272.642 -45.376)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M616.526,131.964l-.187,4.425,4.217,8.15,8.073-9.662s1.939-18.734,1.939-20.81c0,0,.563-16.787-12.958-16.3-7.456.267-9.622,8.069-9.622,17.531,0,9-1.036,16.811,8.538,16.67",
    transform: "translate(-274.068 -44.067)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M599.867,102.666c-5.819-2.739-2.5-12.343,5.759-11.384s9.663-1.041,12.7-1.86c4.754-1.281,13.715,5,11.468,15.837-2.831,13.656-9.117,6.39-9.117,6.39-.559-3.205-.857-6.155-.115-8.089,0,0-14.879,1.844-20.7-.895",
    transform: "translate(-269.101 -40.237)",
    fill: "#051a35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M624.85,158.359a.288.288,0,0,1-.286-.237.291.291,0,0,1,.235-.337,22.465,22.465,0,0,0,5.24-1.81.288.288,0,1,1,.26.515,22.413,22.413,0,0,1-5.4,1.866.4.4,0,0,1-.051,0",
    transform: "translate(-281.554 -70.3)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M619.25,138.66h-.023a3.581,3.581,0,0,1-1.021-.192.758.758,0,0,1-.557-.837,6.647,6.647,0,0,1,.594-2.242.29.29,0,0,1,.382-.144.285.285,0,0,1,.144.382,6.149,6.149,0,0,0-.543,2.05c-.008.121-.011.172.193.254a3.2,3.2,0,0,0,.853.153.289.289,0,0,1-.023.577",
    transform: "translate(-278.437 -60.957)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M618.565,146.821a2.251,2.251,0,0,1-1.371-.534.288.288,0,0,1,.35-.458,1.575,1.575,0,0,0,1.179.4,1.343,1.343,0,0,0,.806-.478.289.289,0,1,1,.469.339,1.914,1.914,0,0,1-1.185.71,1.439,1.439,0,0,1-.249.02",
    transform: "translate(-278.182 -65.652)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M502.194,190.453c0,.85,2.594.781,5.565-.547a14.159,14.159,0,0,0,2-1.062c3.32-2.145,3.891-4.857,3.891-5.9v-.025c-.012-.255-.2-.391-.524-.408-.943-.049-3.04.846-5.487,2.434-.92.6-1.782,1.223-2.551,1.832-2.05,1.631-2.9,2.928-2.9,3.68",
    transform: "translate(-226.391 -82.274)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M673.755,228.687c-5.917,4.447-25,18.281-27.9,19.1l-8-11.2,22.2-16.626L653.3,208.293l9.284-26.875,5.446,13.707,9.123,22.922a9.611,9.611,0,0,1-3.4,10.64",
    transform: "translate(-287.54 -81.784)",
    fill: "#f2f3f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(350.319 130.08)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M637.875,261.578c7.349-6.311,15.068-12.13,22.97-17.7l-.143.411c-.587-2.458-1.064-4.947-1.556-7.431,2.386,7.186,1.985,6.2,2.383,7.475-6.269,4.837-12.885,10.266-23.653,17.249",
    transform: "translate(-637.875 -236.854)",
    fill: "#b6bab6"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M645.645,292.845c.836-.272.448-3.776-.908-6.751-1.815-4.134-4.753-5.234-6.948-4.521l-.024.008c-.25.1-.381.351-.392.73-.093,3.153,6.318,11.17,8.272,10.535",
    transform: "translate(-287.33 -126.843)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M617.879,128.273a.289.289,0,0,1-.127-.549,2.371,2.371,0,0,1,2.186,0,.3.3,0,0,1,.13.39.29.29,0,0,1-.391.13,1.784,1.784,0,0,0-1.671,0,.282.282,0,0,1-.127.029",
    transform: "translate(-278.412 -57.458)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M633.814,127.8a.289.289,0,0,1-.023-.577l3.563-.275a.316.316,0,0,1,.311.266.289.289,0,0,1-.266.311l-3.563.274Z",
    transform: "translate(-285.595 -57.227)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M624.833,130.66a4.149,4.149,0,1,1,3.732-4.128,3.977,3.977,0,0,1-3.732,4.128m0-7.679a3.576,3.576,0,1,0,3.156,3.552,3.4,3.4,0,0,0-3.156-3.552",
    transform: "translate(-279.965 -55.18)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M624.155,130.949a.812.812,0,1,0,.8-.92.868.868,0,0,0-.8.92",
    transform: "translate(-281.371 -58.617)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M627.876,126.642a.288.288,0,0,1-.241-.127,1.92,1.92,0,0,0-1.08-.766,1.289,1.289,0,0,0-.97.288.3.3,0,0,1-.408-.057.292.292,0,0,1,.057-.407,1.818,1.818,0,0,1,1.422-.393,2.457,2.457,0,0,1,1.459,1.015.286.286,0,0,1-.24.446",
    transform: "translate(-281.806 -56.421)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M605.352,126.769a3.7,3.7,0,0,0,3.507,3.839,3.861,3.861,0,0,0,0-7.678,3.7,3.7,0,0,0-3.507,3.839",
    transform: "translate(-272.895 -55.417)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M608.623,130.66a4.149,4.149,0,1,1,3.732-4.128,3.976,3.976,0,0,1-3.732,4.128m0-7.679a3.576,3.576,0,1,0,3.156,3.552,3.4,3.4,0,0,0-3.156-3.552",
    transform: "translate(-272.659 -55.18)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M607.943,130.949a.812.812,0,1,0,.8-.92.868.868,0,0,0-.8.92",
    transform: "translate(-274.063 -58.617)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M611.664,126.642a.288.288,0,0,1-.241-.127,1.92,1.92,0,0,0-1.08-.766,1.292,1.292,0,0,0-.97.288.3.3,0,0,1-.408-.057.292.292,0,0,1,.057-.407,1.82,1.82,0,0,1,1.422-.393A2.456,2.456,0,0,1,611.9,126.2a.286.286,0,0,1-.24.446",
    transform: "translate(-274.498 -56.421)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M589.558,220.248h-.017a.288.288,0,0,1-.271-.305l.435-7.937a.288.288,0,0,1,.288-.271h.017a.288.288,0,0,1,.271.305l-.435,7.937a.288.288,0,0,1-.288.271",
    transform: "translate(-265.645 -95.45)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M543.123,214.27a.288.288,0,0,1-.158-.529l2.968-1.959a.288.288,0,1,1,.317.481l-2.969,1.96a.275.275,0,0,1-.158.048",
    transform: "translate(-244.711 -95.449)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M483.215,150.343l.083.111,4.588,4.635.973,1.186s-2.781-.195-2.262,2.206c0,0-2.336.556-1.14,2.549-3.467,2.262,3.346,8.018,9.76,9.259l.612.927,2.122,3.2c.316-.111.64-.25.955-.389a14.154,14.154,0,0,0,2-1.057,8.024,8.024,0,0,0,3.81-5.116c-.223-.408-.445-.807-.7-1.214a53.8,53.8,0,0,0-20.557-19.344c-1.149-.194-1.2,1.882-.25,3.05",
    transform: "translate(-217.534 -66.395)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M503.593,167.734c-3.259-3.363-.683-5.756-.683-5.756s-1.614-2.012-2.056-2.747c-.848-1.411-.528-3.354.022-3.685,1.98-1.191,9.833,12.636,9.833,12.636",
    transform: "translate(-225.552 -70.088)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M510.519,168.226a.23.23,0,0,1-.2-.119c-1.887-3.317-7.216-12.046-9.212-12.568a.367.367,0,0,0-.3.017,1.809,1.809,0,0,0-.424,1.253,3.778,3.778,0,0,0,.481,2.115c.43.712,2.022,2.7,2.039,2.723a.232.232,0,0,1-.023.314,3.244,3.244,0,0,0-.893,2.124,4.7,4.7,0,0,0,1.583,3.3.232.232,0,0,1-.334.322,5.114,5.114,0,0,1-1.71-3.642,3.656,3.656,0,0,1,.891-2.284c-.393-.495-1.572-1.991-1.949-2.619a4.2,4.2,0,0,1-.545-2.381,2.065,2.065,0,0,1,.648-1.62.837.837,0,0,1,.656-.071c2.593.682,9.215,12.3,9.5,12.792a.227.227,0,0,1-.088.314.233.233,0,0,1-.113.031",
    transform: "translate(-225.363 -69.899)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M494.037,163.662a23.99,23.99,0,0,0,1.995,3.229",
    transform: "translate(-222.714 -73.779)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M495.842,166.935a.231.231,0,0,1-.175-.082,24.187,24.187,0,0,1-2.025-3.272.234.234,0,0,1,.1-.314.237.237,0,0,1,.314.1,24.185,24.185,0,0,0,1.962,3.186.227.227,0,0,1-.025.325.217.217,0,0,1-.15.057",
    transform: "translate(-222.524 -73.59)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M492.193,172.976s1.026,2.314-.59,2.42c-.928.06-3.72-3.49-3.72-3.49",
    transform: "translate(-219.939 -77.496)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M491.4,175.436c-1.018,0-3.413-2.974-3.885-3.577a.231.231,0,0,1,.362-.288c1.323,1.682,2.989,3.4,3.509,3.4h.017a.672.672,0,0,0,.58-.288c.291-.484-.037-1.467-.187-1.807a.231.231,0,0,1,.119-.305.226.226,0,0,1,.305.119c.065.147.625,1.462.158,2.234a1.117,1.117,0,0,1-.947.512Z",
    transform: "translate(-219.749 -77.305)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M490.911,176.89s1.011,2.766-.606,2.871c-.3.019-.753-.36-1.23-.882",
    transform: "translate(-220.477 -79.743)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M490.1,179.807c-.345,0-.786-.305-1.383-.958a.227.227,0,0,1,.014-.325.222.222,0,0,1,.325.014c.682.74.962.806,1.041.806h.005a.646.646,0,0,0,.537-.28c.365-.566.026-1.838-.136-2.282a.233.233,0,0,1,.138-.3.238.238,0,0,1,.3.138c.068.183.645,1.832.088,2.692a1.113,1.113,0,0,1-.9.492Z",
    transform: "translate(-220.287 -79.555)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M494.131,168.664s1.026,2.314-.59,2.42c-.928.06-3.72-3.49-3.72-3.49",
    transform: "translate(-220.813 -75.552)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M493.332,171.124c-1.018,0-3.413-2.977-3.885-3.58a.233.233,0,0,1,.037-.325.228.228,0,0,1,.325.037c1.326,1.685,2.991,3.4,3.512,3.4h.014a.668.668,0,0,0,.58-.291c.291-.481-.037-1.465-.187-1.8a.232.232,0,1,1,.424-.187c.065.147.625,1.459.158,2.231a1.123,1.123,0,0,1-.947.515Z",
    transform: "translate(-220.622 -75.36)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M625.684,297.62a18.934,18.934,0,0,0,6.071-7.4l3.624-1.53c-.916-3.621-3.213-7.534-6.942-7.266-.408.158-.769.3-.991.4a.646.646,0,0,1-.241.065c-8.284.93-9.869,3.467-9.869,3.467l1.586,2.692c-3.057,1.766-5.675,6.529-3.543,6.177l1.427-.361s-.713,2.7,1.743,2.632l.009.009c0,.167.185,2.354,2.29,1.585.721,1.633,2.678,1.12,4.837-.465",
    transform: "translate(-277.065 -126.859)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x1: 2.682,
    y2: 2.68,
    transform: "translate(339.74 164.319)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M618.421,301.921a.232.232,0,0,1-.164-.4l2.684-2.677a.232.232,0,0,1,.328.328l-2.683,2.677a.231.231,0,0,1-.164.068",
    transform: "translate(-278.682 -134.691)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x1: 2.682,
    y2: 2.68,
    transform: "translate(341.496 166.954)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M621.617,306.717a.232.232,0,0,1-.164-.4l2.683-2.681a.232.232,0,1,1,.328.328l-2.683,2.681a.233.233,0,0,1-.164.068",
    transform: "translate(-280.123 -136.852)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x1: 2.682,
    y2: 2.68,
    transform: "translate(343.783 168.54)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M625.782,309.605a.232.232,0,0,1-.164-.4l2.683-2.681a.232.232,0,1,1,.328.328l-2.683,2.68a.231.231,0,0,1-.164.068",
    transform: "translate(-282 -138.154)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y1: 1.041,
    x2: 3.255,
    transform: "translate(341.856 160.143)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M622.276,292.676a.232.232,0,0,1-.071-.453l3.255-1.041a.226.226,0,0,1,.291.15.231.231,0,0,1-.149.291l-3.255,1.04a.2.2,0,0,1-.071.012",
    transform: "translate(-280.42 -131.26)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M639.856,129.919a5.331,5.331,0,0,1,.512-3.375c.975-2.071,2.778-3.278,4.033-2.692,2.044.981,1.086,5.694-1.6,7.261",
    transform: "translate(-288.407 -55.766)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M642.569,131.162a.29.29,0,0,1-.249-.141.286.286,0,0,1,.1-.4c2.523-1.483,3.41-5.891,1.617-6.752-1.1-.5-2.757.665-3.644,2.553a5.029,5.029,0,0,0-.492,3.19.29.29,0,0,1-.218.348.3.3,0,0,1-.348-.217,5.6,5.6,0,0,1,.534-3.565c1.055-2.257,3-3.49,4.414-2.831,2.337,1.124,1.254,6.119-1.569,7.773a.283.283,0,0,1-.147.04",
    transform: "translate(-288.169 -55.527)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M645.546,129.94a.262.262,0,0,1-.093-.014.29.29,0,0,1-.181-.367.87.87,0,0,0-.009-.724.975.975,0,0,0-.568-.39.291.291,0,0,1-.223-.342.286.286,0,0,1,.339-.223,1.526,1.526,0,0,1,.953.665,1.413,1.413,0,0,1,.057,1.2.285.285,0,0,1-.274.195",
    transform: "translate(-290.528 -57.644)",
    fill: "#2d3240"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(239.345 -42.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M225.439,2.6l-.215,42.772a2.579,2.579,0,0,0,2.587,2.6h9.079l-.063,12.547a1.434,1.434,0,0,0,2.354,1.12l16.775-13.667h38.134a2.61,2.61,0,0,0,2.613-2.6L296.921,2.6A2.579,2.579,0,0,0,294.333,0H228.052a2.61,2.61,0,0,0-2.613,2.6",
    transform: "translate(-114.915)",
    fill: "#fce74c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M231.862,8.424,231.673,46.1a1.984,1.984,0,0,0,1.989,2h61.185a2.028,2.028,0,0,0,1.873-1.238,2.078,2.078,0,0,0,.146-.761l.189-37.678a1.993,1.993,0,0,0-2-2H233.871a2.008,2.008,0,0,0-2.009,2",
    transform: "translate(-118.205 -3.278)",
    fill: "#50ad53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M291.518,36.323a6.169,6.169,0,0,0-2.753.648,6.092,6.092,0,0,0-1.937,1.345c-4.394,4.535-7.7,4.542-12.551-.153a6.058,6.058,0,0,0-2.23-1.374,6.194,6.194,0,1,0-.683,11.693,5.8,5.8,0,0,0,3.054-1.717c4.99-5.052,8.325-3.936,12.551.153a6.062,6.062,0,0,0,2.791,1.538,6.193,6.193,0,1,0,1.757-12.133",
    transform: "translate(-134.443 -18.533)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup37);
export default __webpack_public_path__ + "static/media/Group_37.14493fbb980a118c9d20f14b41828a77.svg";
export { ForwardRef as ReactComponent };